import * as React from "react";
import { Grid } from "@mui/material";
import * as moment from "moment";
import { InfoRounded } from "@mui/icons-material";

import { ElementsParallax, Tooltip, AdsComponent } from "components";
import { returnFormatNumber, returnNumFormated } from "utils/validations";
import Logocrom from "assets/video/Logocrom.gif";
import pageStyles from "./RankingStyles";
import { useRanking } from "services";
import useCountDown from "hooks/custom/useCountDown";
import Model from "hooks/Model";

const initTooltips = {
  one: false,
  two: false,
  three: false,
  four: false,
};

function RankingScreen() {
  const styles = pageStyles();
  const [openTooltips, setOpenTooltips] = React.useState(initTooltips);
  const { currentScore, settings, currentPosition, listRanking, loading } =
    useRanking({});
  const { finishedCountdown, currentTime } = useCountDown({
    dateTo: moment(settings?.finalDate, "x"),
  });

  const renderFinalDate = () => {
    let days = currentTime.days;
    let hours = currentTime.hours;
    let minutes = currentTime.minutes;
    let seconds = currentTime.seconds;

    if (settings?.finalDate) {
      if (finishedCountdown || isNaN(days)) {
        days = 0;
        hours = 0;
        minutes = 0;
        seconds = 0;
      }
    } else {
      days = 0;
      hours = 0;
      minutes = 0;
      seconds = 0;
    }

    return (
      <div className={styles.rowTimeBanner}>
        <div>
          <p>{days}</p>
          <p className={styles.labelTimeBanner}>Días</p>
        </div>
        <div className={styles.dividerTimeBanner} />
        <div>
          <p>{hours}</p>
          <p className={styles.labelTimeBanner}>Horas</p>
        </div>
        <div className={styles.dividerTimeBanner} />
        <div>
          <p>{minutes}</p>
          <p className={styles.labelTimeBanner}>Minutos</p>
        </div>
        <div className={styles.dividerTimeBanner} />
        <div>
          <p>{seconds}</p>
          <p className={styles.labelTimeBanner}>Segundos</p>
        </div>
      </div>
    );
  };

  const returnAproxReward = () => {
    if (settings?.accumulated && settings?.prize && currentScore) {
      return ((currentScore / settings.accumulated) * settings?.prize).toFixed(
        2,
      );
    }

    return 0;
  };

  const renderUsers = () => {
    return listRanking.map((user, index) => (
      <div className={styles.itemUser} key={index}>
        <div>{index + 1}</div> <p>{user.email}</p>
        <p style={{ textAlign: "right" }}>{returnFormatNumber(user.score)}</p>
      </div>
    ));
  };

  const changeTooltip = (label) => () => {
    setOpenTooltips((prev) => ({
      ...initTooltips,
      [label]: !prev[label],
    }));
  };

  React.useEffect(() => {
    if (!loading) {
      Model.setData("layoutConfig", { withBg: true });
      Model.setData("stepTutorial", "ranking");
    }
  }, [loading]);

  return (
    <>
      <ElementsParallax variant="leftBg" />
      <AdsComponent />
      <div className={styles.containerBanner}>
        <div className={styles.colInfo}>
          <div className={styles.infoContainer}>
            <h2>Ranking general</h2>
            <p>
              A continuación puedes encontrar la información sobre tu progreso
              en el ranking, comparar con el puntaje de otros usuarios, ver los
              premios y los dias restantes.
            </p>
          </div>
          {settings?.infoBanner?.show ? (
            <div className={styles.infoContainerNews}>
              <h2>{settings.infoBanner.title}</h2>
              <p>{settings.infoBanner.description}</p>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className={styles.imageRanking}>
          <div className={styles.containerImageLogo}>
            <img src={Logocrom} alt="FROIN" className={styles.imageLogo} />
          </div>
          <div className={styles.overlayVideo} />
        </div>
      </div>
      <Grid container className={styles.gridContainer}>
        <Grid
          item
          className={[styles.itemSquare].join(" ")}
          onClick={changeTooltip("one")}
          id="ranking-section-1"
        >
          <div className={styles.divisionSquare}>
            <p className={styles.labelItemSquare}>Posición actual:</p>
            <p className={styles.valueItemSquare}>
              {currentPosition < 1
                ? `${listRanking.length > 0 ? "+" : ""}${listRanking.length}`
                : currentPosition}
            </p>
          </div>
          <Tooltip
            open={openTooltips.one}
            title="Gana cualquier posición"
            text="Nuestro objetivo es que las ganancias sean equitativas para todos nuestros participantes, así que no te preocupes si apareces después de la posición 50, tu recompensa llegará"
            isIcon
          >
            <InfoRounded className={styles.iconInfo} />
          </Tooltip>
        </Grid>
        <Grid
          item
          className={[styles.itemSquare].join(" ")}
          onClick={changeTooltip("two")}
          id="ranking-section-2"
        >
          <div className={styles.divisionSquare}>
            <p className={styles.labelItemSquare}>Tiempo restante:</p>
            <div className={styles.valueItemSquare}>{renderFinalDate()}</div>
          </div>
          <Tooltip
            open={openTooltips.two}
            title="Tiempo límite del Ranking"
            text="Esta es la duración que damos para que cada participante pueda acumular puntaje, por lo tanto esto es lo que queda antes de que se cierre y ya no se puedan acumular más puntos"
            isIcon
          >
            <InfoRounded className={styles.iconInfo} />
          </Tooltip>
        </Grid>
        <Grid
          item
          className={styles.itemSquare}
          onClick={changeTooltip("three")}
          id="ranking-section-3"
        >
          <div className={styles.divisionSquare}>
            <p className={styles.labelItemSquare}>Puntos acumulados:</p>
            <p className={styles.valueItemSquare}>
              {returnNumFormated(currentScore || 0)}
            </p>
          </div>
          <div className={styles.divisionSquare}>
            <p className={styles.labelItemSquare}>Total puntos comunidad:</p>
            <p className={styles.valueItemSquare}>
              {returnNumFormated(settings?.accumulated || 0)}
            </p>
          </div>
          <Tooltip
            open={openTooltips.three}
            title="Puntaje de ranking"
            text="El premio que te correspondrá al finalizar el Ranking será proporcional a los puntos que generaste frente a los puntos de la comunidad. Ejemplo: Si tus puntos corresponden al 10% de todos los puntos generados por la comunidad, entonces te correspondrá el 10% del premio acumulado."
            isIcon
          >
            <InfoRounded className={styles.iconInfo} />
          </Tooltip>
        </Grid>
        <Grid
          item
          className={styles.itemSquare}
          onClick={changeTooltip("four")}
          id="ranking-section-4"
        >
          <div className={styles.divisionSquare}>
            <p className={styles.labelItemSquare}>Total $FROIN a repartir:</p>
            <p className={styles.valueItemSquare}>
              {returnNumFormated(parseFloat(String(settings?.prize)))}
            </p>
          </div>
          <div className={styles.divisionSquare}>
            <p className={styles.labelItemSquare}>Tu premio actual $FROIN:</p>
            <p className={styles.valueItemSquare}>
              {returnNumFormated(parseFloat(String(returnAproxReward())))}
            </p>
          </div>
          <Tooltip
            open={openTooltips.four}
            title="Aquí todos ganan"
            text="Te mostramos el premio que te corresponde según tu participación en la comunidad, aprovecha cada día para acumular más puntos y subir en el Ranking"
            isIcon
          >
            <InfoRounded className={styles.iconInfo} />
          </Tooltip>
        </Grid>
        <Grid item className={styles.itemSquare} id="ranking-section-5">
          <p className={styles.labelItemSquare}>Primeras posiciones</p>
          <div className={styles.usersList}>{renderUsers()}</div>
        </Grid>
        <Grid item className={styles.itemSquare} id="ranking-section-6">
          <p className={styles.labelItemSquare}>Términos y condiciones</p>
          <div className={styles.scrollTerms}>
            <p className={styles.textTerms}>
              {settings?.terms?.replace(/\\n/g, "\n")}
            </p>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default RankingScreen;
